export const video = ()=> {
    let videoTrigger;

    const videoSections = document.querySelectorAll('.video-section')

    videoSections?.forEach(section=> {
        const videoPreviewWrapper = section.querySelector('.video-section__preview')
        const videoPreviewPlayer = section.querySelector('.video-section__preview video')
        const videoPopup = section.querySelector('.video-section__popup')
        const videoPopupPlayer = section.querySelector('.video-section__popup video')

        if (videoPreviewPlayer) {
            const videoURL = videoPreviewPlayer?.getAttribute('data-src');
            const preloadVideo = document.createElement('video');

            preloadVideo.src = videoURL;
            preloadVideo.preload = 'auto';
            preloadVideo.load();

            const videoLoad = ()=> {
                if (window.scrollY > ((section.getBoundingClientRect().top + window.scrollY) - window.innerHeight)) {
                    if (videoPreviewPlayer.getAttribute('data-src') && !videoPreviewPlayer.getAttribute('src')) {
                        videoPreviewPlayer.setAttribute("src",videoPreviewPlayer.getAttribute('data-src'))
                    }
                }
            }

            videoLoad()

            window.addEventListener('scroll',()=> {
                videoLoad()
            })
        }

        let startClick = false

        window.addEventListener('click',(e)=> {
            if (e.target !== videoPopupPlayer && startClick) {
                if (videoPopup.classList.contains('show')) {
                    videoPopup.classList.remove('show')
                    videoPreviewWrapper?.classList.add('play')
                    if (videoPopupPlayer.getAttribute('src')) {
                        videoPopupPlayer.pause()
                    }
                }
                startClick = false
            } else if (e.target === videoPreviewWrapper || e.target.closest('.video-section__preview')) {
                videoPopup?.classList.add('show')
                videoPreviewWrapper?.classList.remove('play')
                if (videoPreviewPlayer.getAttribute('data-src') && !videoPopupPlayer.getAttribute('src')) {
                    videoPopupPlayer.setAttribute("src",videoPreviewPlayer.getAttribute('data-src'))
                }
                if (videoPopupPlayer.getAttribute('src')) {
                    videoPopupPlayer.play()
                }
                startClick = true
            }
        })

        const videoSrollAnimation = ()=> {
            if (videoPreviewWrapper) {
                if (videoTrigger) {
                    videoTrigger.kill();
                }
                videoTrigger = ScrollTrigger.create({
                    trigger: section,
                    start: 'top 80%',
                    end: 'bottom 20%',
                    onEnter: () => {
                        document.querySelector('.video-section__preview').classList.add('play');
                    },
                    onLeave: () => {
                        document.querySelector('.video-section__preview').classList.remove('play');
                    },
                    onEnterBack: () => {
                        document.querySelector('.video-section__preview').classList.add('play');
                    },
                    onLeaveBack: () => {
                        document.querySelector('.video-section__preview').classList.remove('play');
                    },
                });
            }
        }

        videoSrollAnimation()

        window.addEventListener('resize',videoSrollAnimation)


    })

}